import { ERoutes } from '../../types/app-routes';

export const dashboardRoutes = [
  {
    path: ERoutes.DASHBOARD,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./components/dashboard.component').then((m) => m.DashboardComponent),
      },
    ],
  },
];
